import { CenteredBlocks } from "@components/site/CenteredBlocks"
import { SiteFooter } from "@components/site/SiteFooter"
import { defineView } from "eddev/views"
import { PageProvider } from "../contexts/PageContext"

export default defineView("page", (props) => {
  return (
    <PageProvider {...props.page?.page}>
      <CenteredBlocks contentBlocks={props.page?.contentBlocks} />
      <SiteFooter />
    </PageProvider>
  )
})
